const config = {
  LIVE_IMAGE_BASE_URL: "https://images.reactbytes.com/react-bytes/og-images/",
  BIG_VERIFICATION_CODE: "D9055E1076388AB5F6E2BA66A8D29654",
};

export default config;
